import Field from 'components/Form/Field';
import FormActions from 'components/Form/FormActions';
import FormResult from 'components/Form/FormResult';
import InputText from 'components/Form/InputText';
import SubmitButton from 'components/Form/SubmitButton';
import SideBySide from 'components/Layout/SideBySide';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import SectionHeader from 'components/SectionHeader';
import {FC} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {c, t} from 'ttag';
import {setUrl} from 'utils/request';
import {onApiError} from 'utils/request-axios/utils';

import {useDuplicateCustomTemplate} from '../services';
import {
    CustomTemplateDuplicateBackendData,
    CustomTemplateDuplicateFormData,
} from './types';

const Page: FC = () => {
    const {
        data: {displayName, mid},
    } = useBackend<CustomTemplateDuplicateBackendData>();
    const methods = useForm<CustomTemplateDuplicateFormData>({
        defaultValues: {displayName: t`(Copy) ${displayName}`},
    });

    const apiDuplicate = useDuplicateCustomTemplate(mid);

    const handleSubmit = async (formData: CustomTemplateDuplicateFormData) => {
        await apiDuplicate
            .mutateAsync(formData)
            .then((response) => {
                if (response.name === 'file_based_customtemplate') {
                    setUrl(
                        window.Urls.file_based_customtemplate_edit_view(
                            response.data.mid,
                        ),
                    );
                } else if (response.name === 'customtemplate') {
                    setUrl(
                        window.Urls.customtemplate_edit_view(response.data.mid),
                    );
                } else {
                    throw new Error(`Unknown template type: ${response.name}`);
                }
            })
            .catch(onApiError(methods));
    };

    return (
        <>
            <NavigationTabs.DocumentSettings selection="customTemplates" />
            <SectionHeader level={1} title={t`Duplicate Document Template`} />
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(handleSubmit)}>
                    <SideBySide className="mt-6">
                        <Field label={t`Source Document Template`} type="value">
                            {displayName}
                        </Field>
                        <InputText
                            label={c('duplicate').t`Name`}
                            name="displayName"
                            required={true}
                            requiredType="hidden"
                        />
                        <FormResult />
                        <FormActions align="left">
                            <SubmitButton>{t`Duplicate`}</SubmitButton>
                        </FormActions>
                    </SideBySide>
                </form>
            </FormProvider>
        </>
    );
};

export default Page;
